export default {
  sm: `
  환경을 생각한 에너지
  절감을 실현하다.
  `,
  lg: `
  환경을 생각한 에너지 절감을 실현하다.
  `,
};
